var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 8.99966C20.9997 8.68279 20.9378 8.3689 20.8166 8.07611C20.6954 7.78332 20.5175 7.51742 20.293 7.29376L16.7052 3.70597C16.4816 3.4815 16.2157 3.30355 15.9229 3.18238C15.6301 3.06121 15.3162 2.99923 14.9993 3.00001H4.99989C4.46948 3.00001 3.9608 3.21071 3.58575 3.58576C3.2107 3.96081 3 4.46949 3 4.99989V18.9991C3 19.5295 3.2107 20.0382 3.58575 20.4132C3.9608 20.7883 4.46948 20.999 4.99989 20.999H18.9991C19.5295 20.999 20.0382 20.7883 20.4132 20.4132C20.7883 20.0382 20.999 19.5295 20.999 18.9991V8.99966Z",
    stroke: "#1C1356",
    strokeWidth: 1.99989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0016 3V7.99971C15.0016 8.26492 15.1069 8.51926 15.2944 8.70678C15.482 8.89431 15.7363 8.99966 16.0015 8.99966H21.0012M8.00195 12.9994H8.01195M16.0015 12.9994H16.0115M10.0018 15.9993C10.0018 15.9993 10.8018 16.9992 12.0017 16.9992C13.3017 16.9992 14.0016 15.9993 14.0016 15.9993",
    stroke: "#1C1356",
    strokeWidth: 1.99989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerPhoto);
export default __webpack_public_path__ + "static/media/sticker-photo.2ae362f7.svg";
export { ForwardRef as ReactComponent };